import { ref, reactive, computed, watch } from 'vue';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-236114c6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "revenue-header"
};
const _hoisted_2 = {
  class: "filter-content"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = {
  class: "time-content"
};
const _hoisted_5 = {
  class: "time-select-content"
};
const _hoisted_6 = {
  class: "filter-list"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "time-title"
}, "时区", -1));
const _hoisted_8 = {
  class: "filter-list"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "time-title"
}, "月份", -1));
const _hoisted_10 = {
  class: "filter-list product-filter"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "time-title"
}, "产品名称", -1));
const _hoisted_12 = {
  class: "appListPopover-content"
};
const _hoisted_13 = {
  class: "appListPopover-content-title"
};
const _hoisted_14 = {
  class: "inf-label"
};
const _hoisted_15 = {
  class: "inf-value"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "复制", -1));
const _hoisted_17 = {
  class: "right"
};
import { selectByDimensionType, selectDbtIdByStudioId, selectDimensionByDbtId } from '@/api/pay';
import { useStore } from '@/store';
import dayjs from 'dayjs';
import { getNode, detailFields, searchFields, getAppListInformation, copy } from '@/common';
import { ProductSelect } from '@dbt/product-select';
import '@dbt/product-select/dist/style.css';
import { getRevenueDisplayName } from '../data/revenueDisplayName';
export default /*#__PURE__*/_defineComponent({
  __name: 'RevenueHeader',
  emits: ['returnSearch'],
  setup(__props, {
    emit
  }) {
    // 时区选项列表
    const zoneList = [{
        label: '北京时间（UTC+8）',
        value: 'Asia/Shanghai'
      }, {
        label: '世界协调时间（UTC）',
        value: 'UTC'
      }, {
        label: '太平洋标准时间 (PST/UTC-8)',
        value: 'UTC-8'
      }, {
        label: '太平洋夏令时间 (PDT/UTC-7)',
        value: 'UTC-7'
      }],
      // 时间周期选项列表
      periodList = [{
        label: '月',
        value: 'month'
      }, {
        label: '总计',
        value: 'sum'
      }];
    // 时间相关的表单状态
    const getDefaultMonthRange = () => [dayjs().subtract(7, 'day'), dayjs().subtract(1, 'day')];
    const selectedMonthRange = ref(getDefaultMonthRange());
    const formState = reactive({
      startTime: selectedMonthRange.value[0].startOf('month').format('YYYYMMDD'),
      endTime: selectedMonthRange.value[1].endOf('month').format('YYYYMMDD'),
      recentDay: '7-1',
      dynamic: 0,
      fromDayToDay: 0,
      useServerTime: false
    });
    const handleMonthRangeChange = months => {
      if (!(months !== null && months !== void 0 && months[0]) || !(months !== null && months !== void 0 && months[1])) return;
      formState.startTime = months[0].startOf('month').format('YYYYMMDD');
      formState.endTime = months[1].endOf('month').format('YYYYMMDD');
    };
    // 各种筛选项的数据列表
    const appList = ref([]),
      // 应用列表
      channelList = ref([]),
      // 渠道列表
      regionList = ref([]),
      // 地区列表
      verList = ref([]),
      // 版本列表
      prodList = ref([]),
      // 产品列表
      timeZoneType = ref('Asia/Shanghai'),
      // 当前选择的时区
      datePeriod = ref('month'),
      // 当前选择的时间周期
      dbtIdList = ref([]),
      // 选中的应用ID列表
      appVersionList = ref([]),
      // 选中的版本列表
      payChnl = ref([]),
      // 选中的支付渠道列表
      proIdList = ref([]),
      // 选中的产品ID列表
      pkgIdList = ref([]),
      // 选中的包名ID列表
      regionIdList = ref([]),
      // 选中的地区ID列表
      studioList = ref(),
      // 工作室列表
      pkgList = ref(),
      // 包名列表
      studioChecked = ref([]),
      // 选中的工作室列表
      productSelectRef = ref(null),
      // 产品选择器引用
      studioSelectRef = ref(null),
      // 工作室选择器引用
      pkgSelectRef = ref(null),
      // 包名选择器引用
      chanlSelectRef = ref(null),
      // 渠道选择器引用
      regionSelectRef = ref(null),
      // 地区选择器引用
      versionSelectRef = ref(null),
      // 版本选择器引用
      prodSelectRef = ref(null),
      // 产品选择器引用
      isExpanded = ref(false); // 低频筛选项是否展开
    // 获取用户信息
    const userInfo = computed(() => useStore().userInfo && JSON.parse(useStore().userInfo));
    // 获取应用数据
    const getAppData = async (autoCheck = false) => {
        try {
          const {
            code,
            data
          } = await selectDbtIdByStudioId(studioChecked.value);
          if (code === '0') {
            var _productSelectRef$val;
            appList.value = data.map(item => {
              var _item$extData;
              const filePath = getRevenueDisplayName(item.dimensionCode, ((_item$extData = item.extData) === null || _item$extData === void 0 ? void 0 : _item$extData.filePath) || '-');
              return {
                ...item,
                checked: false,
                // label: item.dimensionName,
                label: filePath || item.dimensionName,
                value: item.dimensionCode,
                ...item.extData,
                filePath,
                extData: {
                  ...item.extData,
                  filePath
                }
              };
            });
            (_productSelectRef$val = productSelectRef.value) === null || _productSelectRef$val === void 0 || _productSelectRef$val.initializeOptions(appList.value);
            if (autoCheck) {
              setTimeout(() => {
                var _appList$value;
                dbtIdList.value = (_appList$value = appList.value) === null || _appList$value === void 0 ? void 0 : _appList$value.map(item => item.value);
                returnChecked();
                // dbtRef.value?.onCheckAllChange({ target: { checked: true } })
              });
            }
          }
        } catch (e) {}
      },
      // 获取工作室列表数据
      getStudioList = async () => {
        try {
          const {
            code,
            data
          } = await selectByDimensionType({
            dimensionType: 'studio_group_id'
          });
          if (code === '0') {
            var _studioSelectRef$valu;
            studioList.value = data === null || data === void 0 ? void 0 : data.map(item => {
              return {
                ...item,
                checked: false,
                label: item.dimensionName,
                value: item.dimensionCode,
                ...item.extData
              };
            });
            (_studioSelectRef$valu = studioSelectRef.value) === null || _studioSelectRef$valu === void 0 || _studioSelectRef$valu.initializeOptions(studioList.value);
          }
        } catch (e) {}
      },
      // 获取渠道相关数据
      getChannel = async arr => {
        try {
          const {
            code,
            data
          } = await selectDimensionByDbtId(arr);
          if (code === '0') {
            var _data$app_version, _data$prod_id, _data$pay_chnl, _data$country, _data$pkg, _chanlSelectRef$value, _pkgSelectRef$value, _regionSelectRef$valu, _versionSelectRef$val, _prodSelectRef$value;
            verList.value = data === null || data === void 0 || (_data$app_version = data.app_version) === null || _data$app_version === void 0 ? void 0 : _data$app_version.map(item => {
              return {
                ...item,
                checked: false,
                label: item.dimensionName,
                value: item.dimensionCode
              };
            });
            prodList.value = data === null || data === void 0 || (_data$prod_id = data.prod_id) === null || _data$prod_id === void 0 ? void 0 : _data$prod_id.map(item => {
              return {
                ...item,
                checked: false,
                label: item.dimensionName ? item.dimensionName + '(' + item.dimensionCode + ')' : item.dimensionCode,
                value: item.dimensionCode
              };
            });
            channelList.value = data === null || data === void 0 || (_data$pay_chnl = data.pay_chnl) === null || _data$pay_chnl === void 0 ? void 0 : _data$pay_chnl.map(item => {
              return {
                ...item,
                checked: false,
                label: item.dimensionName,
                value: item.dimensionCode
              };
            });
            regionList.value = data === null || data === void 0 || (_data$country = data.country) === null || _data$country === void 0 ? void 0 : _data$country.map(item => {
              return {
                ...item,
                checked: false,
                label: item.dimensionName,
                value: item.dimensionCode
              };
            });
            pkgList.value = data === null || data === void 0 || (_data$pkg = data.pkg) === null || _data$pkg === void 0 ? void 0 : _data$pkg.map(item => {
              return {
                ...item,
                checked: false,
                label: item.dimensionName,
                value: item.dimensionCode
              };
            });
            (_chanlSelectRef$value = chanlSelectRef.value) === null || _chanlSelectRef$value === void 0 || _chanlSelectRef$value.initializeOptions(channelList.value);
            (_pkgSelectRef$value = pkgSelectRef.value) === null || _pkgSelectRef$value === void 0 || _pkgSelectRef$value.initializeOptions(pkgList.value);
            (_regionSelectRef$valu = regionSelectRef.value) === null || _regionSelectRef$valu === void 0 || _regionSelectRef$valu.initializeOptions(regionList.value);
            (_versionSelectRef$val = versionSelectRef.value) === null || _versionSelectRef$val === void 0 || _versionSelectRef$val.initializeOptions(verList.value);
            (_prodSelectRef$value = prodSelectRef.value) === null || _prodSelectRef$value === void 0 || _prodSelectRef$value.initializeOptions(prodList.value);
          }
        } catch (e) {}
      },
      // 各种选择器的回调处理函数
      returnStudio = arr => {
        studioChecked.value = arr;
        dbtIdList.value = [];
        getAppData(!!arr.length);
      },
      returnChecked = () => {
        getChannel(dbtIdList.value);
      },
      returnChanl = arr => {
        payChnl.value = arr;
      },
      returnRegion = arr => {
        regionIdList.value = arr;
      },
      returnVersion = arr => {
        appVersionList.value = arr;
      },
      returnPkg = arr => {
        pkgIdList.value = arr;
      },
      returnPro = arr => {
        proIdList.value = arr;
      },
      // 切换低频筛选项的展开/收起
      toggleExpand = () => {
        isExpanded.value = !isExpanded.value;
      },
      // 重置搜索条件
      resetSearch = () => {
        timeZoneType.value = 'Asia/Shanghai';
        datePeriod.value = 'month';
        dbtIdList.value = [];
        studioChecked.value = [];
        appVersionList.value = [];
        payChnl.value = [];
        proIdList.value = [];
        regionIdList.value = [];
        pkgIdList.value = [];
        pkgList.value = [];
        selectedMonthRange.value = getDefaultMonthRange();
        handleMonthRangeChange(selectedMonthRange.value);
        Object.assign(formState, {
          recentDay: '7-1',
          dynamic: 0,
          fromDayToDay: 0,
          useServerTime: false
        });
        getAppData();
        getStudioList();
        search();
      },
      // 处理时间格式转换
      handleTime = time => {
        const year = time.substring(0, 4);
        const month = time.substring(4, 6);
        const day = time.substring(6, 8);
        const date = new Date(Number(year), Number(month) - 1, Number(day));
        return date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0');
      },
      // 执行搜索
      search = () => {
        const searchObj = {
          appVersionList: appVersionList.value,
          datePeriod: datePeriod.value,
          dbtIdList: dbtIdList.value,
          endDate: handleTime(formState.endTime),
          startDate: handleTime(formState.startTime),
          payChnl: payChnl.value,
          proIdList: proIdList.value,
          pkgList: pkgIdList.value,
          regionList: regionIdList.value,
          timeZoneType: timeZoneType.value
        };
        emit('returnSearch', searchObj);
      };
    watch(() => {
      var _userInfo$value;
      return (_userInfo$value = userInfo.value) === null || _userInfo$value === void 0 ? void 0 : _userInfo$value.id;
    }, (n, o) => {
      if (n !== o) {
        getAppData();
        getStudioList();
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_range_picker = _resolveComponent("a-range-picker");
      const _component_SvgIcon = _resolveComponent("SvgIcon");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_a_select, {
        class: "time-zone",
        placeholder: "请选择时区",
        options: zoneList,
        value: timeZoneType.value,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => timeZoneType.value = $event),
        getPopupContainer: _unref(getNode)
      }, null, 8, ["value", "getPopupContainer"]), _createVNode(_component_a_tooltip, null, {
        title: _withCtx(() => [_createTextVNode("若与海外平台对账，请切换至世界协调时间。")]),
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "questionMark",
          "class-name": "mark-icon"
        })]),
        _: 1
      })]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_a_range_picker, {
        class: "month-range-picker",
        value: selectedMonthRange.value,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => selectedMonthRange.value = $event),
        picker: "month",
        format: "YYYY-MM",
        placeholder: ['开始月份', '结束月份'],
        "allow-clear": false,
        getPopupContainer: _unref(getNode),
        onChange: handleMonthRangeChange
      }, null, 8, ["value", "getPopupContainer"]), _createVNode(_component_a_tooltip, null, {
        title: _withCtx(() => [_createTextVNode("咨询时间：客户端实际支付时间")]),
        default: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "questionMark",
          "class-name": "mark-icon time-tips"
        })]),
        _: 1
      }), _createVNode(_component_a_select, {
        class: "time-period",
        placeholder: "请选择时间周期",
        options: periodList,
        value: datePeriod.value,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => datePeriod.value = $event),
        getPopupContainer: _unref(getNode)
      }, null, 8, ["value", "getPopupContainer"])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_unref(ProductSelect), {
        ref_key: "productSelectRef",
        ref: productSelectRef,
        modelValue: dbtIdList.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => dbtIdList.value = $event),
        multiple: true,
        "show-select-all": true,
        "show-extra": true,
        "search-fields": _unref(searchFields),
        "max-tag-count": 1,
        "show-detail": true,
        layout: "vertical",
        descriptionField: "dimensionName",
        width: "100%",
        customClassName: "revenue-product-label",
        "popup-class-name": "vertical-product-select",
        placeholder: "请选择",
        detailFields: _unref(detailFields),
        onChange: returnChecked,
        "show-bottom-border": ""
      }, {
        detail: _withCtx(({
          detail
        }) => [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createVNode(_component_SvgIcon, {
          iconClass: "informationIcon",
          class: "informationIcon"
        }), _createTextVNode(" " + _toDisplayString(detail.label), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getAppListInformation)(detail.extData), child => {
          return _openBlock(), _createElementBlock("div", {
            key: child.label,
            class: "inf-line"
          }, [_createElementVNode("div", _hoisted_14, _toDisplayString(child.label) + "：", 1), _createElementVNode("div", _hoisted_15, _toDisplayString(child.value), 1), _createVNode(_component_a_tooltip, {
            placement: "top"
          }, {
            title: _withCtx(() => [_hoisted_16]),
            default: _withCtx(() => [_createVNode(_component_SvgIcon, {
              iconClass: "copy",
              class: "dbt-copyIcon",
              onClick: $event => _unref(copy)(child.value)
            }, null, 8, ["onClick"])]),
            _: 2
          }, 1024)]);
        }), 128))])]),
        _: 1
      }, 8, ["modelValue", "search-fields", "detailFields"])])])])]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_a_button, {
        onClick: resetSearch
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        onClick: search
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      })])])]);
    };
  }
});